import { canViewRequests } from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

export const inboxSteps: TourStepConfig[] = [
  {
    id: "inbox-tabs",
    target: "inbox.tabs",
    title: "Filter by status",
    content:
      "Narrow the list to what is still in progress, already completed, or declined, instead of reading every row.",
    placement: "bottom",
    when: canViewRequests,
  },
  {
    id: "inbox-list",
    target: "inbox.list",
    title: "Documents sent to you",
    content:
      "Each row shows who sent it and where it stands. The button on the right changes to match — sign it, download the signed copy, or open the details.",
    placement: "bottom",
    when: canViewRequests,
  },
];

export default inboxSteps;
